(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup-dialog"] && !Shopify.designMode) return;
  try {
    class EmailSignupDialog extends HTMLElement {
    connectedCallback() {
      const justSubmitted =
        this.querySelector('.email-signup-dialog__state--success') ||
        this.querySelector('.email-signup-dialog__error');

      if (!justSubmitted) return;

      customElements.whenDefined('dialog-component').then(() => {
        this.querySelector('dialog-component')?.showDialog?.();
      });
    }
  }

  if (!customElements.get('email-signup-dialog')) {
    customElements.define('email-signup-dialog', EmailSignupDialog);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('category-filter-cards'))
  customElements.define('category-filter-cards', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.category-filter__options');
      this.trigger = this.querySelector('.facets__summary');
      this.results = document.getElementById(this.dataset.results);
      this.connectedController = new AbortController();
      const { signal } = this.connectedController;
      this.trigger?.addEventListener('click', (e) => { e.stopPropagation(); this.toggleOpen(); }, { signal });
    }

    disconnectedCallback() {
      this.connectedController?.abort();
      this.closePanel();
    }

    toggleOpen() {
      if (this.hasAttribute('open')) {
        this.closePanel();
      } else {
        this.openPanel();
      }
    }

    openPanel() {
      this.openController?.abort();
      this.setAttribute('open', '');
      this.panel?.removeAttribute('inert');
      this.trigger?.setAttribute('aria-expanded', 'true');
      this.results?.classList.add('category-filter-open');
      const activeLink = this.querySelector('a[aria-current]') || this.querySelector('a.category-filter__card');
      activeLink?.focus();
      this.openController = new AbortController();
      const signal = this.openController.signal;
      document.addEventListener('click', (e) => { if (!this.panel?.contains(e.target)) this.closePanel(); }, { signal });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closePanel(); }, { signal });
    }

    closePanel() {
      const returnFocus = this.panel?.contains(document.activeElement);
      this.removeAttribute('open');
      this.panel?.setAttribute('inert', '');
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.results?.classList.remove('category-filter-open');
      this.openController?.abort();
      if (returnFocus) this.trigger?.focus();
    }

  });
  } catch(e) { console.error(e); }
})();

})();
